<template>
  <div class="enter tes-card pa-2 pa-md-7">
    <IndicationsWrapper>
      <v-row>
        <v-col cols="12" sm="7">
          <account-select :onlyIsOwner="false" :disabled="loading">
            <span class="select-prepend">{{$t('personalAccount')}}</span>
          </account-select>
        </v-col>
        <v-col cols="12" sm="4" class="subtitle-1 attention">
          <div>
            <v-icon>mdi-alert-circle</v-icon>
          </div>

          <div class="ml-2">
            <a
              href="#"
              @click.prevent="infoDialog = true"
              class="indication-info-dialog-link"
            >
              <span>
                {{$t('pages.indicationsEnter.infoLimitPart1')}}
                {{$t('pages.indicationsEnter.infoLimitPart2')}}
                <span class="tes-orange-text">{{$t('pages.indicationsEnter.infoLimitPart3')}}</span>
                {{$t('pages.indicationsEnter.infoLimitPart4')}}
              </span>
            </a>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-0">
          <loader-wrapper
            :loading="loading"
            :showNoDataText="!indicationsByBillingId.length"
            :opacity="0.8"
          >
            <v-table-wrapper
              v-if="windowSize.x > 768"
              :headers="headers"
              :items="indicationsByBillingId"
              class="data-table"
              ref="table"
            >
              <template v-slot:header.text.meterNumber>
                <span v-if="currentLocale === 'ru'">{{$t('pages.indicationsEnter.device').split(' ')[0]}}<br />{{$t('pages.indicationsEnter.device').split(' ')[1]}}</span>
                <span v-else>{{$t('pages.indicationsEnter.device')}} </span>
              </template>
              <template v-if="checkPlaceMeters" v-slot:header.text.place>
                {{$t('pages.indicationsEnter.place').split(' ')[0]}} <br />{{$t('pages.indicationsEnter.place').split(' ')[1]}}
              </template>
              <template v-slot:header.text.date>
                {{$t('pages.indicationsEnter.dateLastIndication').split(' ')[0]}}
                <br />{{$t('pages.indicationsEnter.dateLastIndication').split(' ')[1]}} <br />{{$t('pages.indicationsEnter.dateLastIndication').split(' ')[2]}}
              </template>
              <template v-slot:header.text.lastIndication>
                {{$t('pages.indicationsEnter.lastIndication').split(' ')[0]}}
                <br />{{$t('pages.indicationsEnter.lastIndication').split(' ')[1]}}
              </template>
              <template v-slot:header.text.indicationSource>
                {{$t('pages.indicationsEnter.methodTransmitting').split(' ')[0]}} <br />{{$t('pages.indicationsEnter.methodTransmitting').split(' ')[1]}}<br />
                 {{$t('pages.indicationsEnter.methodTransmitting').split(' ')[2]}} <br /> {{$t('pages.indicationsEnter.methodTransmitting').split(' ')[3]}}
              </template>
              <template v-slot:header.text.currentIndication>
                {{$t('pages.indicationsEnter.currentIndication').split(' ')[0]}}
                <br />{{$t('pages.indicationsEnter.currentIndication').split(' ')[1]}}
              </template>
              <template v-slot:header.text.tariff>
              <div class="d-flex align-center justify-center" style="gap: 8px;">
                  Тариф
                  <v-tooltip bottom max-width="380" content-class="default-vuetify-tooltip"  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="orange">mdi-alert-circle</v-icon>
                    </template>
                    <span>
                      {{$t('pages.indicationsEnter.tariffInfo')}}
                    </span>
                  </v-tooltip>
                </div>
                <div class="sub-item">{{$t('pages.indicationsEnter.tariffSumPart1')}}<br />{{$t('pages.indicationsEnter.tariffSumPart2')}}</div>
              </template>
              <template v-slot:header.text.subTotal>
                {{$t('pages.indicationsEnter.calculation').split(' ')[0]}}
                <br />{{$t('pages.indicationsEnter.calculation').split(' ')[1]}}, {{$t('currency')}}.
              </template>

              <template v-slot:item.serviceName="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  <span>{{ item.serviceName }}</span>
                  <div class="sub-item align-lef">{{ item.zone }}</div>
                </span>
              </template>

              <template v-slot:item.date="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{ humanDate(item.date) }}
                </span>
              </template>

              <template v-slot:item.lastIndication="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{
                    item.lastIndication === "0" ? $t('pages.indicationsEnter.empty') : +item.lastIndication
                  }}
                </span>
              </template>

              <template v-slot:item.indicationSource="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{
                    item.indicationSource
                  }}
                </span>
              </template>

              <template
                v-slot:item.currentIndication="{ item }"
                class="red-border"
              >
                <span @click="checkLimitEnterIndications()">
                  <div class="current-indication-container">
                    <div
                      class="current-indication-placeholder"
                      :class="
                        currentDay > 25 ? 'current-indication-disabled' : ''
                      "
                    >
                      {{
                        item.currentIndication
                          ? item.currentIndication
                          : $t('pages.indicationsEnter.change')
                      }}
                    </div>
                    <div class="current-indication-value">
                      <v-edit-dialog
                        v-if="currentDay <= 25 && !isIndicationLimitPeriod.value"
                      >
                        <template v-slot:input>
                          <v-text-field
                            class="curentMeterField"
                            :value="item.currentIndication"
                            type="number"
                            :disabled="item.status === 'false'"
                            :label="
                              item.status === 'false'
                                ? $t('pages.indicationsEnter.verificationLimit')
                                : $t('pages.indicationsEnter.inputIndication')
                            "
                            color="#ff721c"
                            @change="saveCurrentIndication($event, item)"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </div>
                  </div>
                </span>
              </template>

              <template v-slot:item.consumption="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{
                    item.currentIndication && !isNaN(item.currentIndication)
                      ? (
                          item.currentIndication -
                          item.lastIndication.replace(/,/g, ".")
                        ).toFixed(3)
                      : 0
                  }}
                </span>
              </template>

              <template v-slot:item.tariff="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  <template v-if="item.tariff.length">
                    <div v-for="tariff in item.tariff" :key="tariff.value">
                      <span>{{ tariff.value }}</span>
                      <!-- <div class="sub-item">{{tariff.measure}}</div> -->
                    </div>
                  </template>
                  <span v-else>{{$t('pages.indicationsEnter.notTariff')}}</span>
                </span>
              </template>

              <template v-slot:item.subTotal="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  <div v-if="isHeating(item.tariff)" class="subtotal">
                    <span class="subtotal-dash"> &mdash; </span>
                    <v-tooltip bottom max-width="380">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="red--text subtotal-icon"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-alert-circle
                        </v-icon>
                      </template>
                      <span class="table-tooltip">
                        {{$t('pages.indicationsEnter.heatingInfoPart1')}}
                        <br />
                        {{$t('pages.indicationsEnter.heatingInfoPart2')}}     
                      </span>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    {{
                      subItemTotal(
                        item.tariff,
                        item.currentIndication,
                        item.lastIndication
                      ).toFixed(2)
                    }}
                  </div>
                </span>
              </template>

              <template v-slot:item.notification="{}">
                <v-icon class="mark-red">mdi-close-circle-outline</v-icon>
              </template>
            </v-table-wrapper>

            <v-data-table
              v-else
              :headers="headers"
              :items="indicationsByBillingId"
              class="data-table"
              ref="table"
            >
              <template v-slot:item.serviceName="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  <span>{{ item.serviceName }}</span>
                  <div class="sub-item align-lef">{{ item.zone }}</div>
                </span>
              </template>

              <template v-slot:item.date="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{ humanDate(item.date) }}
                </span></template
              >

              <template v-slot:item.lastIndication="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{
                    item.lastIndication === "0" ? this.$t('pages.indicationsEnter.empty') : +item.lastIndication
                  }}
                </span></template
              >

              <template v-slot:item.indicationSource="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{
                    item.indicationSource
                  }}
                </span></template
              >

              <template
                v-slot:item.currentIndication="{ item }"
                class="red-border"
              >
                <span @click="checkLimitEnterIndications()">
                  <div class="current-indication-container">
                    <div
                      class="current-indication-placeholder"
                      :class="
                        currentDay > 25 ? 'current-indication-disabled' : ''
                      "
                    >
                      {{
                        item.currentIndication
                          ? item.currentIndication
                          : $t('pages.indicationsEnter.change')
                      }}
                    </div>
                    <div class="current-indication-value">
                      <v-edit-dialog
                        v-if="currentDay <= 25 && !isIndicationLimitPeriod.value"
                      >
                        <template v-slot:input>
                          <v-text-field
                            class="curentMeterField"
                            :value="item.currentIndication"
                            type="number"
                            :disabled="item.status === 'false'"
                            :label="
                              item.status === 'false'
                                ? $t('pages.indicationsEnter.verificationLimit')
                                : $t('pages.indicationsEnter.inputIndication')
                            "
                            color="#ff721c"
                            @change="saveCurrentIndication($event, item)"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </div>
                  </div>
                </span>
              </template>

              <template v-slot:item.consumption="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  {{
                    item.currentIndication && !isNaN(item.currentIndication)
                      ? (
                          item.currentIndication -
                          item.lastIndication.replace(/,/g, ".")
                        ).toFixed(3)
                      : 0
                  }}
                </span>
              </template>

              <template v-slot:item.tariff="{ item }">
                <div class='d-flex'>
                  <v-tooltip bottom max-width="380" content-class="default-vuetify-tooltip"  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="orange" class="px-2">mdi-alert-circle</v-icon>
                    </template>
                    <span>
                      {{$t('pages.indicationsEnter.tariffInfo')}}
                    </span>
                  </v-tooltip>
                  <span @mouseover="showModalNonIndication(item)">
                    <template v-if="item.tariff.length">
                      <div v-for="tariff in item.tariff" :key="tariff.value">
                        <span style="text-align: center;">{{ tariff.value }}</span>
                        <!-- <div class="sub-item">{{tariff.measure}}</div> -->
                      </div>
                    </template>
                    <span v-else>{{$t('pages.indicationsEnter.notTariff')}}</span>
                  </span>
                </div>
              </template>

              <template v-slot:item.subTotal="{ item }">
                <span @mouseover="showModalNonIndication(item)">
                  <div v-if="isHeating(item.tariff)" class="subtotal">
                    <span class="subtotal-dash"> &mdash; </span>
                    <v-tooltip bottom max-width="380">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="red--text subtotal-icon"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-alert-circle
                        </v-icon>
                      </template>
                      <span class="table-tooltip">
                        {{$t('pages.indicationsEnter.heatingInfoPart1')}}
                        <br />
                        {{$t('pages.indicationsEnter.heatingInfoPart2')}}
                      </span>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    {{
                      subItemTotal(
                        item.tariff,
                        item.currentIndication,
                        item.lastIndication
                      ).toFixed(2)
                    }}
                  </div>
                </span>
              </template>

              <template v-slot:item.notification="{}">
                <v-icon class="mark-red">mdi-close-circle-outline</v-icon>
              </template>
            </v-data-table>

            <v-row class="mt-4" no-gutters v-if="indicationsByBillingId.length">
              <v-col cols="12" sm="6" class="mt-2">
                <span class="fs-18 tes-main-grey-text mr-1"
                :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'"
                  >{{$t('pages.indicationsEnter.preliminaryCalculation')}}:</span
                >
                <span class="tes-black-text helvetica-medium fs-18 ml-1">{{
                  Number.parseFloat(subTotalSum).toFixed(2) || "0.00"
                }}</span>
                <span class="fs-14 tes-light-grey-text ml-1">{{$t('currency')}}.</span>
                
              </v-col>
              <v-col cols="5" sm="4" class="mt-2">
                <a v-if="checkZeroTariff" class ="fs-16  float-sm-right" href="https://tatenergosbyt.ru/communal/calculations/">{{$t('pages.indicationsEnter.tariffsAndStandards')}}</a>
              </v-col>
              <v-col class="mt-3 mt-sm-0 text-center text-sm-rigth">
                <v-btn
                  @click="setCurrentIndication()"
                  :disabled="
                    disableSetCurrentIndicationButton || currentDay > 25
                  "
                  class="save-btn text-none float-sm-right mt-3 mt-sm-0"
                  :loading="metersIsSending"
                  >{{$t('pages.indicationsEnter.save')}}</v-btn
                >
              </v-col>
            </v-row>

            <!-- <br /> -->

            <!-- ВРЕМЕННО СКРЫТО, НЕ УДАЛЯТЬ -->

            <!-- <v-row
              class="mt-1"
              no-gutters
              v-if="!userSettings.isMkdUser">
              <v-col class="mt-2">
                  <span class="helvetica-medium fs-18 tes-main-grey-text mr-1">К оплате по ЕПД:</span>
                  <span class="tes-black-text helvetica-medium fs-18 ml-1">{{ Number.parseFloat(accountInfo.toPay).toFixed(2) || '0.00' }}</span>
                  <span class="fs-14 tes-light-grey-text ml-1">руб.</span>
              </v-col>
              <v-col
                  cols="12"
                  sm="3"
                  class="mt-2">
                  <span class="helvetica-medium fs-18 tes-main-grey-text mr-1">Предварительный расчёт:</span>
                  <span class="tes-black-text helvetica-medium fs-18 ml-1">{{ Number.parseFloat(subTotalSum).toFixed(2) || '0.00'}}</span>
                  <span class="fs-14 tes-light-grey-text ml-1">руб.</span>
              </v-col>
              <v-col
                  cols="12"
                  sm="3"
                  class="mt-2">
                  <span class="helvetica-medium fs-18 tes-main-grey-text mr-1">Итого к оплате:</span>
                  <span class="tes-black-text helvetica-medium fs-18 ml-1">{{ Number.parseFloat(totalSum).toFixed(2) || '0.00'}}</span>
                  <span class="fs-14 tes-light-grey-text ml-1">руб.</span>
              </v-col>
              <v-col
                  cols="12"
                  sm="3"
                  class="text-center text-sm-right">
                  <v-btn
                      @click="paymentDialog = true"
                      class="text-none orange-button float-sm-rigth mt-3 mt-sm-0"
                      width="173">Оплатить
                  </v-btn>
              </v-col>
          </v-row>-->

            <!-- ВРЕМЕННО СКРЫТО, НЕ УДАЛЯТЬ -->
          </loader-wrapper>
        </v-col>
      </v-row>
      <ModalIndicationInfo v-model="infoDialog"></ModalIndicationInfo>
      <ModalIndicationHighCurrentValue 
        v-model="showHighConsumptionModal" 
        @save-indication="confirmHighConsumption"
        @cancel-indication="cancelHighConsumption"
      />
      <ModalPayment v-model="paymentDialog" :toPay="totalSum"></ModalPayment>
      <ModalReadingsInfo v-model="readingsInfo"></ModalReadingsInfo>
      <modal-not-indications
        v-if="showIndicationsError"
        v-model="showIndicationsError"
        @closeFindError="closeIndicationsError"
        :errorMes="errorMes"
      />
      <modal-check-meter
        v-if="checkMeter"
        v-model="checkMeter"
        :date="statusMeter"
      ></modal-check-meter>
    </IndicationsWrapper>
    <modal-indication-limit
      v-model="showIndicationsLimit"
      :message="currentLocale === 'ru' ? isIndicationLimitPeriod.mesHtml : isIndicationLimitPeriod.mesTatHtml"
      :header="currentLocale === 'ru' ? isIndicationLimitPeriod.headerHtml : isIndicationLimitPeriod.headerTatHtml"
    ></modal-indication-limit>
  </div>
</template>

<script>
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect";
import ModalIndicationInfo from "../../../components/modals/ModalIndicationsInfo";
import ModalIndicationHighCurrentValue from '../../../components/modals/ModalIndicationHighCurrentValue';
import ModalPayment from "../../../components/modals/ModalPayment";
import { mask } from "vue-the-mask";
import { mapGetters, mapState } from "vuex";
import IndicationsWrapper from "@/components/indications/wrappers/index.vue";
import {
  UPDATE_DEVICE_DATA,
  UPDATE_DEVICE_INDICATION,
} from "@/store/mutation-types";
import VTableWrapper from "../../../components/wrapper/VTableWrapper";
import moment from "moment";
import ModalReadingsInfo from "../../../components/modals/ModalReadingsInfo";
import ModalNotIndications from "../../../components/modals/ModalError";
import LoaderWrapper from "../../../components/common/LoaderWrapper";
import ModalCheckMeter from "../../../components/modals/ModalCheckMeter";
import ModalIndicationLimit from "../../../components/modals/ModalIndicationLimit.vue";

export default {
  name: "Indications",
  layout: "main",
  directives: {
    mask,
  },
  components: {
    "account-select": PersonalAccountSelect,
    "v-table-wrapper": VTableWrapper,
    IndicationsWrapper,
    ModalIndicationInfo,
    ModalIndicationHighCurrentValue,
    ModalNotIndications,
    ModalPayment,
    LoaderWrapper,
    ModalReadingsInfo,
    ModalCheckMeter,
    ModalIndicationLimit,
  },
  computed: {
    ...mapState("indication", ["indications"]),
    ...mapState("account", ["userSettings", "accountInfo", "selectedAccount"]),
    ...mapGetters("indication", ["indicationsByBillingId"]),
    ...mapGetters("locale",["currentLocale"]),
    ...mapState("payments", ["isIndicationLimitPeriod"]),

    subTotalSum() {
      return this.indications.reduce(
        (sum, item) =>
          sum +
          this.subTotal(
            item.tariff,
            item.currentIndication,
            item.lastIndication
          ),
        0
      );
    },
    totalSum() {
      return this.accountInfo.toPay + this.subTotalSum;
    },
    disableSetCurrentIndicationButton() {
      return !this.indicationsByBillingId.some((i) => i.currentIndication);
    },
    checkPlaceMeters() {
      if (this.indicationsByBillingId.some((i) => i.place)) return true;
      else {
        //   this.headers = this.headers.filter(x=> x.value !== "place");
        return false;
      }
    },
    checkZeroTariff(){
        if (this.indications.some((i) => !i.tariff.length || i.tariff[0].value == 0)) return true;
    },
    errorMes(){
      return this.$t('modals.modalError.info');
    },
    headers() {
      if (this.checkPlaceMeters) {
        return [
          {
            text: "Ресурс",
            value: "serviceName",
            width: 200,
            align: "center",
            isSortable: false,
            isResizable: true,
            class: "subtitle-1 font-weight-bold",
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.device'),
            value: "meterNumber",
            align: "center",
            isSortable: false,
            isResizable: true,
            class: "subtitle-1 font-weight-bold",
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.place'),
            value: "place",
            align: "center",
            isSortable: false,
            isResizable: true,
            class: "subtitle-1 font-weight-bold",
            th: {
              style: {
                height: "60px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.dateLastIndication'),
            value: "date",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.lastIndication'),
            value: "lastIndication",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.methodTransmitting'),
            value: "indicationSource",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.currentIndication'),
            value: "currentIndication",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.consumption'),
            value: "consumption",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: "Тариф",
            value: "tariff",
            width: 200,
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.calculation') + "," + this.$t('currency') +".",
            value: "subTotal",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: "",
            value: "notification",
            width: 60,
            th: {
              style: {
                height: "80px",
              },
            },
          },
        ];
      } else {
        return [
          {
            text: "Ресурс",
            value: "serviceName",
            width: 200,
            align: "center",
            isSortable: false,
            isResizable: true,
            class: "subtitle-1 font-weight-bold",
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.device'),
            value: "meterNumber",
            align: "center",
            isSortable: false,
            isResizable: true,
            class: "subtitle-1 font-weight-bold",
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.dateLastIndication'),
            value: "date",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.lastIndication'),
            value: "lastIndication",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.methodTransmitting'),
            value: "indicationSource",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.currentIndication'),
            value: "currentIndication",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.consumption'),
            value: "consumption",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: "Тариф",
            value: "tariff",
            width: 200,
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: this.$t('pages.indicationsEnter.calculation') + "," + this.$t('currency') +".",
            value: "subTotal",
            align: "center",
            isSortable: false,
            isResizable: true,
            td: {
              class: "subtitle-1 font-weight-bold",
            },
            th: {
              style: {
                height: "80px",
              },
            },
          },
          {
            text: "",
            value: "notification",
            width: 60,
            th: {
              style: {
                height: "80px",
              },
            },
          },
        ];
      }
    },
  },
  watch: {    
    selectedAccount: {
        immediate: true,
        handler() {
            this._modalShown = false;
            this._pendingRequest = null;
            this.loading = true;
            Promise.all([
                this.$store.dispatch("indication/loadIndications"),
                this.$store.dispatch("account/getAccountInfo"),
            ]).finally(() => {
                this.loading = false;
            });
        },
    },
    indicationsByBillingId: {
      handler(val) {
        // заменяю все undrfainded и прочее на '0'
        let newindicationsByBillingId = val.map((a) => {
          if (!a.lastIndication) a.lastIndication = "0";
          return a;
        });
        val = newindicationsByBillingId;
      },
    },
    indications: {
      handler(val) {
        let needUpdate = false;
        const lastIndicationsWithoutComma = val.map((a) => {
          if (a.lastIndication && a.lastIndication.includes(',')) {
            needUpdate = true;
            return {
              ...a,
              lastIndication: a.lastIndication.replace(/,/, ".")
            };
          }
          return {...a}
        })
        if (needUpdate) {
          this.$store.commit('indication/SET_INDICATIONS', lastIndicationsWithoutComma);
        }
      },
    },
  },
  data: () => ({
    infoDialog: false,
    showHighConsumptionModal: false,
    readingsInfo: false,
    paymentDialog: false,
    metersIsSending: false,
    showIndicationsError: false,
    checkMeter: false,
    masCheckWindowFirst: [],
    statusMeter: "",
    loading: false,
    currentDay: new Date().getDate(),
    showIndicationsLimit: false,
    windowSize: {
      x: 0,
      y: 0,
    },
    _modalShown: false,
    _pendingRequest: null,
  }),
  mounted() {
    this.$store.dispatch("payments/getIndicationLimitPeriod");
    this.showIndicationsLimit = this.isIndicationLimitPeriod.value;

    this.onResize();
    // window.addEventListener('resize',  this.onResize)
    this.openReadingsInfo();
  },
  methods: {
    openReadingsInfo() {
      let curDate = new Date();
      let curDay = curDate.getDate();
      let nextMonthFirstDay = new Date(
        curDate.getFullYear(),
        curDate.getMonth() + 1,
        1
      );
      if (curDay >= 26 && curDate < nextMonthFirstDay) {
        this.readingsInfo = true;
      }
    },
    checkLimitEnterIndications() {
      console.log(this.checkPlaceMeters);
      this.showIndicationsLimit = this.isIndicationLimitPeriod.value;
    },
    openInfoDialog() {
      this.infoDialog = true;
    },
    validateConsumptions(request) {
      if (this._modalShown) {
        this.sendIndications(request);
        return;
      }
      let showModal = false;

      for (const item of request.indications) {
        const isElectricity = item.serviceName && item.serviceName.toLowerCase().includes('электроснабжение');
        
        if (!isElectricity) continue;

        const userInput = parseFloat(String(item.value).replace(/,/g, ".")) || 0;
        const lastValue = parseFloat(String(item.lastIndication).replace(/,/g, ".")) || 0;

        const previousExpenses = parseFloat(item.previousExpenses) || 0;
        const checkType = item.checkType || 'normal';

        const currentExpenses = userInput - lastValue;

        switch (checkType) {
          case 'threshold_expenses': {
            console.log('Проверка по расходу (3900)');
            if (currentExpenses >= 3900) {
                console.log('Модалка');
                showModal = true;
                break;
            }
          }
          case 'threshold_value': {
            console.log('Проверка по значению (3900)');
            if (userInput >= 3900) {
              console.log('Модалка');
              showModal = true;
              break;
            }
          }
          case 'normal': {
            console.log('Обычная проверка (previousExpenses * 10)');
            const threshold = previousExpenses * 10;
            console.log(`Порог: ${threshold}`);
            if (previousExpenses > 0 && currentExpenses >= threshold) {
                console.log('Модалка');
                showModal = true;
                break;
            }
          }
        }
      }
      if (showModal) {
        this._pendingRequest = request;
        this.showHighConsumptionModal = true;
      } else {
        this.sendIndications(request);
      }
    },
    confirmHighConsumption() {
      this._modalShown = true;    
      if (this._pendingRequest) {
        this.sendIndications(this._pendingRequest)
      }
      this._pendingRequest = null;
      this.showHighConsumptionModal = false;
    },
    cancelHighConsumption() {
      this._modalShown = true;
      this._pendingRequest = null;
      this.showHighConsumptionModal = false;
    },
    sendIndications(request) {
      this.metersIsSending = true;
      this.$store.dispatch("indication/setCurrentIndication", request)
        .then(() => {
          this.$store.dispatch("indication/loadIndications");
        })
        .finally(() => {
          this.metersIsSending = false;
          this._pendingRequest = null;
        });
    },
    saveCurrentIndication(item, current) {
      if (current.status != null) {
        if (!this.masCheckWindowFirst.includes(current.meterNumber)) {
          this.statusMeter = current.status;
          this.checkMeter = true;
        }

        this.masCheckWindowFirst.push(current.meterNumber);
      }

      let lastInd = +current.lastIndication.replace(/,/g, ".");

      current.consumption = isNaN(lastInd) ? Number(item) : Number(item) - lastInd;

      if (lastInd <= item) {
        this.$store.commit("indication/" + UPDATE_DEVICE_DATA, {
          guid: current.guid,
          currentIndication: Number(item),
          consumption: current.consumption,
        });
        current.currentIndication = item;
      } else {
        this.$store.commit("common/ADD_ALERT", {
          text: this.$t('pages.indicationsEnter.inputError'),
          type: "error",
        });
      }
    },
    subTotal(tariff, current, last) {
      let tariffValueWithoutHeating = tariff.filter(
        (item) => item.measure.trim().toLowerCase() != "гкал."
      );
      let tariffValue = tariffValueWithoutHeating.reduce(
        (sum, el) => sum + (el.value || 0),
        0
      );
      return (
        tariffValue *
          (Number(current).toFixed(3) - Number(last ? last : 0).toFixed(3)) || 0
      );
    },
    subItemTotal(tariff, current, last) {
      let tariffValue = tariff.reduce((sum, el) => sum + (el.value || 0), 0);
      return (
        tariffValue *
          (Number(current).toFixed(3) - Number(last ? last : 0).toFixed(3)) || 0
      );
    },
    isHeating(tariff) {
      return !!tariff.find(
        (item) => item.measure && item.measure.trim().toLowerCase() === "гкал."
      );
    },
    humanDate(date) {
      let human = new Date(date);

      let result = moment(human).format("DD.MM.YYYY");

      return date == 0 ? this.$t('pages.indicationsEnter.empty') : result;
    },
    setCurrentIndication() {
      let request = {
        // domHoz: this.selectedAccount.domHoz,
        indications: [],
      };
      for (let i = 0; i < this.indicationsByBillingId.length; i++) {
        // for (let i = 0; i < 1; i++) {
          request.indications.push({
            guid: this.indicationsByBillingId[i].guid,
            value: this.indicationsByBillingId[i].currentIndication,
            numberOfZones: this.indicationsByBillingId[i].numberOfZones,

            lastIndication: this.indicationsByBillingId[i].lastIndication,
            previousExpenses: this.indicationsByBillingId[i].previousExpenses,
            checkType: this.indicationsByBillingId[i].checkType,
            serviceName: this.indicationsByBillingId[i].serviceName,
          });
        }
        
        // this.metersIsSending = true;
        
        this.validateConsumptions(request)      
      //     // let data = response.data.result;
      //     // data.forEach((item, index) => {
      //     //   request.indications.forEach(requestItem => {
      //     //     if (item.guid === requestItem.guid) {
      //     //       if (item.result) {
      //     //         this.$store.commit(
      //     //           "indication/" + UPDATE_DEVICE_INDICATION,
      //     //           Object.assign(item, requestItem)
      //     //         );
      //     //       } else {
      //     //         const tr = document.querySelector(
      //     //           `.v-table-wrapper-body-common-table-tbody-row[row="${index}"]`
      //     //         );
      //     //         tr.classList.add("error-line");
      //     //       }
      //     //     }
      //     //   });
      //     // });
      //   })
      //   .finally(() => {
      //     this.metersIsSending = false;
      //   });
    },    
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight,
      };
    },
    closeIndicationsError() {
      this.showIndicationsError = false;
    },
    showModalNonIndication(item) {
      if (item.lastIndication == 0) {
        this.showIndicationsError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.enter {
  .attention {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-self: center;
    margin-left: 5px;
    margin-right: 5px;

    i {
      color: $main-orange;
    }

    div {
      display: flex;
      align-self: center;
      justify-self: center;
    }

    span {
      color: black;

      span {
        color: $main-orange;
      }
    }
  }

  .tab-active {
    color: white;
    background-color: $main-orange;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .sub-item {
    opacity: 0.5;
  }

  .current-indication {
    &-container {
      position: relative;
      width: 100%;
      height: 100%;
    }

    $offsetTop: 12px;

    &-placeholder {
      top: 0;
      bottom: 0;
      color: #0068a3;
      position: absolute;
      // font-size: 12px;
      font-weight: 600;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      z-index: 4;
      text-decoration: underline;
      text-decoration-style: dotted;
      @media screen and (max-width: 600px) {
        position: static;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
    }

    &-value {
      top: 0;
      width: 100%;

      padding-top: 0;
      bottom: 0;
      /*background: red;*/
      z-index: 5;
      position: absolute;
    }

    &-disabled {
      opacity: 0.5;
    }
  }

  .save-btn {
    background-image: $green-gradient;
    color: white;
  }

  .select-prepend {
    white-space: nowrap;
  }

  .indication-info-dialog-link {
    text-decoration: none;
  }

  .mark-red {
    display: none;
    float: right;
    color: red;
  }

  .v-table-wrapper-body-common-table-tbody-row.error-line {
    .mark-red {
      display: inline;
    }

    td {
      border-top: 2px solid red !important;
      border-bottom: 2px solid red !important;

      &:first-child {
        border-left: 2px solid red !important;
      }

      &:last-child {
        border-right: 2px solid red !important;
      }
    }
  }

  .subtotal {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .subtotal-dash {
    margin-right: 8px;
  }

  .subtotal-icon {
    cursor: pointer;
  }
}

.v-tooltip__content {
  border: 2px solid #d0cece;
  border-radius: 16px;
  background-color: #f2f2f2;
  color: $main-black;
  font-weight: 500;
  line-height: 1.2rem;
}

.curentMeterField {
  width: 250px;
}

.default-vuetify-tooltip.v-tooltip__content {
  border: none;
  background-color: #616161;
  color: white;
  font-weight: 400;
  padding: 8px 16px;
}
</style>
